import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=44cd6b1a&scoped=true&"
import script from "./RuleForm.vue?vue&type=script&lang=js&"
export * from "./RuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd6b1a",
  null
  
)

export default component.exports